"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fiLocaleData = require("i18next-icu/locale-data/fi");
exports.default = fiLocaleData;
//# sourceMappingURL=fi.js.map